import * as React from 'react';
import { EcgTest } from 'webportalclient';
import { Modal } from '../misc/components/modal';

interface GlasgowModalProps {
    test: EcgTest;
    onClose: () => void;
}

export const GlasgowModal = ({ test, onClose }: GlasgowModalProps) => {
    return (<Modal header="Glasgow Algorithm Statements" show={true} closeModalHandler={() => onClose()}>
        <div className="modal-body">
            <table className="table table-striped">
                <tbody>
                    <tr>
                        <td><b>Glasgow Summary Statement</b></td>
                        <td>{test.summaryStatement}</td>
                    </tr>
                    <tr>
                        <td><b>Glasgow Rhythm Analysis Statement</b></td>
                        <td>{test.analysisStatement}</td>
                    </tr>
                    <tr>
                        <td><b>Glasgow Diagnostic Statement</b></td>
                        <td>{test.diagnosticStatement}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={() => onClose()}>Close</button>
        </div>
    </Modal>)
}
